(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2082],{

/***/ 98350:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/download-icon.722784f4.svg","height":21,"width":19});

/***/ }),

/***/ 52082:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cart_CartItems; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/cart/CartItemTile.jsx + 1 modules
var CartItemTile = __webpack_require__(46757);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./components/cart/OrderSummary/SocialShare.jsx + 1 modules
var SocialShare = __webpack_require__(13200);
;// CONCATENATED MODULE: ./src/components/cart/OrderSummary/cartContstants.js
const analyticEventData = {
    eventAction: "cart:landing page:share cart",
    eventName: "cart:landing page:share cart",
    internalLinkPosition: "cart",
    internalLinkType: "cart:navigation",
    internalLinkZoneName: "cart:landing page:order summary"
};


// EXTERNAL MODULE: ./components/cart/localization.js
var localization = __webpack_require__(96286);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./constants/index.js + 1 modules
var constants = __webpack_require__(55111);
;// CONCATENATED MODULE: ./public/icons/print-grey.svg
/* harmony default export */ var print_grey = ({"src":"/_next/static/media/print-grey.ea4718c1.svg","height":17,"width":17});
// EXTERNAL MODULE: ./store/features/authSlice.js
var authSlice = __webpack_require__(24899);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./utils/constants.js
var utils_constants = __webpack_require__(11310);
// EXTERNAL MODULE: ./components/cart/analytics/index.js
var analytics = __webpack_require__(29063);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react-csv/index.js
var react_csv = __webpack_require__(83461);
// EXTERNAL MODULE: ./public/icons/down-arrow-sort.svg
var down_arrow_sort = __webpack_require__(36868);
// EXTERNAL MODULE: ./public/icons/download-icon.svg
var download_icon = __webpack_require__(98350);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./utils/cart.js + 1 modules
var utils_cart = __webpack_require__(33273);
// EXTERNAL MODULE: ./components/cart/Pagination/index.jsx + 3 modules
var Pagination = __webpack_require__(28231);
// EXTERNAL MODULE: ./components/cart/AbandonedCarts/index.module.scss
var index_module = __webpack_require__(22358);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./public/icons/arrow-right.svg
var arrow_right = __webpack_require__(29157);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./public/icons/back-arrow.svg
var back_arrow = __webpack_require__(64821);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
;// CONCATENATED MODULE: ./components/cart/AbandonedCarts/index.js



















const AbandonedCarts = (param)=>{
    let { staticTexts , onClick , currencySign , loadAbandonedCart  } = param;
    const { abandonedCarts =[]  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [sort, setSort] = (0,react.useState)("desc");
    const [headers, setHeaders] = (0,react.useState)([
        {
            label: "Cart ID",
            key: "collabCartId"
        },
        {
            label: "Cart Creation",
            key: "createtime"
        },
        {
            label: "Customer Email",
            key: "initiatedBy"
        },
        {
            label: "Customer Name",
            key: "customerName"
        }
    ]);
    (0,react.useEffect)(()=>{
        dispatch((0,cartSlice/* getAbandonedCarts */.lS)());
    }, []);
    const [totalData, setTotalData] = (0,react.useState)(0);
    const [totalResults, setTotalResults] = (0,react.useState)(0);
    const [tableData, setTableData] = (0,react.useState)([]);
    const [curRows, setCurRows] = (0,react.useState)(constants.DEFAULT_PRODUCT_COUNT_PLP);
    const [paginationState, setPaginationState] = (0,react.useState)({
        rows: constants.DEFAULT_PRODUCT_COUNT_PLP,
        start: 0
    });
    (0,react.useEffect)(()=>{
        let arrayForSort = [
            ...abandonedCarts
        ];
        if (arrayForSort.length) {
            arrayForSort.sort((a, b)=>{
                return +new Date(b.createtime) - +new Date(a.createtime);
            });
        }
        setTotalData(arrayForSort);
        setTableData(arrayForSort.slice(0, constants.DEFAULT_PRODUCT_COUNT_PLP));
        setTotalResults(arrayForSort.length);
    }, [
        abandonedCarts
    ]);
    (0,react.useEffect)(()=>{
        if (totalData.length) {
            setTableData(totalData.slice(paginationState.start, paginationState.start + paginationState.rows));
        }
    }, [
        paginationState,
        totalData
    ]);
    const displayPrint = true;
    const productsPerPage = constants.PRODUCTS_PER_PAGE;
    const { rows , start  } = paginationState;
    (0,react.useEffect)(()=>{
        tableData.forEach((item)=>{
            if ((item === null || item === void 0 ? void 0 : item.lineitems.length) > 0) {
                item.lineitems.forEach((item, i)=>{
                    const header = {
                        label: "SKU Code",
                        key: "lineitems[".concat(i, "].sku")
                    };
                    if (!headers.find((i)=>i.key === header.key)) {
                        headers.push(header);
                        headers.push({
                            label: "Line Item Qty",
                            key: "lineitems[".concat(i, "].qty")
                        });
                        headers.push({
                            label: "Item MRP",
                            key: "lineitems[".concat(i, "].itemMRP")
                        });
                        headers.push({
                            label: "Item Seling Price",
                            key: "lineitems[".concat(i, "].itemSP")
                        });
                    }
                });
            }
        });
        if (!headers.find((i)=>i.label === "Pincode")) {
            headers.push({
                label: "Pincode",
                key: "shippingInfo.pincode"
            }, {
                label: "City",
                key: "shippingInfo.city"
            }, {
                label: "State",
                key: "shippingInfo.state"
            }, {
                label: "Device Type",
                key: "deviceType"
            });
        }
        setHeaders(headers);
    }, [
        tableData
    ]);
    const handleLoadCart = (cart)=>{
        if (cart.recoveredStatus === false) {
            dispatch((0,cartSlice/* getCart */.dv)({
                klId: cart.collabCartId
            })).unwrap().then((res)=>{
                (0,utils_cart/* setCustomerCartId */.VN)(res.id);
                onClick();
                loadAbandonedCart(true);
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }).catch((error)=>{
                dispatch((0,genericSlice/* showToast */.CF)({
                    message: "Cart is not available.",
                    isVisible: true
                }));
                console.error("error", error);
            });
        }
    };
    const returnToCart = ()=>{
        onClick();
    };
    const onLoadMore = ()=>{
        setPaginationState((state)=>({
                ...state,
                rows: rows + rows
            }));
    };
    const onRows = (rows)=>{
        setCurRows(rows);
        setPaginationState({
            rows,
            start: 0
        });
    };
    const handleBackToTop = ()=>{
        var ref;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        (ref = document.getElementById("kf-product-list-tile-details-0")) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const onSort = ()=>{
        const sortOrder = sort === "asc" ? "desc" : "asc";
        let arrayForSort = [
            ...totalData
        ];
        if (sortOrder === "desc") {
            arrayForSort.sort((a, b)=>{
                return +new Date(b.createtime) - +new Date(a.createtime);
            });
        } else {
            arrayForSort.sort((a, b)=>{
                return +new Date(a.createtime) - +new Date(b.createtime);
            });
        }
        setSort(sortOrder);
        setTotalData(arrayForSort);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: (index_module_default()).AbandonedCarts,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "back-to-cart",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: back_arrow/* default */.Z === null || back_arrow/* default */.Z === void 0 ? void 0 : back_arrow/* default.src */.Z.src,
                        alt: "Back",
                        className: "pr-10 pb-5",
                        height: "20",
                        width: "40"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: "back-to-cart-text",
                        onClick: returnToCart,
                        children: "Back to Cart"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "header",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        className: "heading",
                        children: "Abandoned Carts"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "Button_buttonWrapper__9Vvy_ kf-react-button button p-4 large ghost ",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_csv.CSVLink, {
                            data: tableData,
                            headers: headers,
                            filename: "Abandoned cart report.csv",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                                className: "kf-react-button button  p-3 large ghost",
                                role: "button",
                                tabIndex: "0",
                                label: "",
                                type: "ghost",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: download_icon/* default.src */.Z.src,
                                        width: 20,
                                        height: 20,
                                        alt: "arrow",
                                        className: "pr-5"
                                    }),
                                    "Export (",
                                    tableData.length,
                                    ") Carts"
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("table", {
                className: "table custom-table-rwd",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("thead", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "Cart Id"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "Customer"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("th", {
                                    onClick: onSort,
                                    children: [
                                        "Date",
                                        sort === "desc" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "pl-10",
                                            "aria-hidden": "true",
                                            src: down_arrow_sort/* default.src */.Z.src,
                                            alt: "down-arrow"
                                        }) : null
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "Status"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                    children: "Total"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {})
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("tbody", {
                        children: tableData.map((cart)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                onClick: ()=>handleLoadCart(cart),
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "underline",
                                            children: cart.collabCartId
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: cart.customerName
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        children: moment_default()(cart.createtime).format("lll")
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "mobile-label",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "border ".concat(cart.recoveredStatus === true ? "active" : cart.recoveredStatus === false ? "label" : ""),
                                            children: cart.recoveredStatus === true ? "Recovered" : cart.recoveredStatus === false ? "Not Recovered" : ""
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "mobile-price",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                            className: "cart-item__total-price hide-mobile-price",
                                            value: cart.cartValue / 100,
                                            displayType: "text",
                                            thousandSeparator: true,
                                            prefix: currencySign,
                                            decimalScale: 2,
                                            fixedDecimalScale: true,
                                            thousandsGroupStyle: "lakh"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                        className: "mobile-arrownav",
                                        children: cart.recoveredStatus === false && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: arrow_right/* default.src */.Z.src,
                                            width: 20,
                                            height: 20,
                                            alt: "arrow"
                                        })
                                    })
                                ]
                            }, cart.createtime))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                page: "cart",
                totalResults,
                productsPerPage,
                onRows,
                displayPrint,
                staticTexts,
                curRows,
                handleBackToTop,
                onLoadMore
            })
        ]
    });
};
/* harmony default export */ var cart_AbandonedCarts = (AbandonedCarts);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 10 modules
var esm = __webpack_require__(52786);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
// EXTERNAL MODULE: ./components/core/Tag/index.module.scss
var Tag_index_module = __webpack_require__(60635);
var Tag_index_module_default = /*#__PURE__*/__webpack_require__.n(Tag_index_module);
;// CONCATENATED MODULE: ./components/core/Tag/index.js



const Tag = (props)=>{
    const { text  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (Tag_index_module_default()).TagWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            className: "Tag__text",
            children: text
        })
    });
};
Tag.propTypes = {
    text: prop_types.string.isRequired
};
/* harmony default export */ var core_Tag = (Tag);

// EXTERNAL MODULE: ./components/cart/utils.js
var utils = __webpack_require__(65875);
// EXTERNAL MODULE: ./components/cart/cartHelper.js
var cartHelper = __webpack_require__(44753);
;// CONCATENATED MODULE: ./public/icons/trash-icon.svg
/* harmony default export */ var trash_icon = ({"src":"/_next/static/media/trash-icon.017aba5c.svg","height":23,"width":19});
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx + 1 modules
var Checkbox = __webpack_require__(34846);
// EXTERNAL MODULE: ./components/cart/cartAnalytics.js
var cartAnalytics = __webpack_require__(96514);
// EXTERNAL MODULE: ./components/core/Modal/Modal.jsx + 2 modules
var Modal = __webpack_require__(95357);
// EXTERNAL MODULE: ./components/core/ConfirmationModal/confirmation-modal.module.scss
var confirmation_modal_module = __webpack_require__(15340);
var confirmation_modal_module_default = /*#__PURE__*/__webpack_require__.n(confirmation_modal_module);
;// CONCATENATED MODULE: ./components/core/ConfirmationModal/ConfirmationModal.jsx





const ConfirmationModal = (param)=>{
    let { showModal =false , setShowModal =()=>{} , onConfirm =()=>{} , onCancel =()=>{} , title ="" , desc =""  } = param;
    const [loading, setLoading] = (0,react.useState)(false);
    const handleConfirm = ()=>{
        setLoading(true);
        onConfirm().finally(()=>{
            setLoading(false);
            setShowModal(false);
        });
    };
    const handleCancel = ()=>{
        onCancel();
        setShowModal(false);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (confirmation_modal_module_default()).confirmationModal,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
            showModal: showModal,
            onModalClose: ()=>setShowModal(false),
            hideCloseIcon: loading,
            isConfirm: true,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "confirmation-modal",
                children: [
                    title ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "confirmation-modal__title",
                        children: title
                    }) : null,
                    desc ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "confirmation-modal__desc",
                        children: desc
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "confirmation-modal__cta",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                customClass: "confirmation-modal__button",
                                label: "Yes",
                                flexible: true,
                                type: "black",
                                onClick: handleConfirm,
                                loading: loading,
                                role: "button",
                                size: "small"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                customClass: "confirmation-modal__button",
                                label: "No",
                                flexible: true,
                                type: "ghost",
                                onClick: handleCancel,
                                disabled: loading,
                                role: "button",
                                size: "small"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var ConfirmationModal_ConfirmationModal = (ConfirmationModal);

;// CONCATENATED MODULE: ./components/cart/CartItems.jsx
























const CartItems = (props)=>{
    var ref;
    const { dispatchCallback , cartItems , loading , cartId , cartKey ="" , mode , showAlert , title , isMerge , onMerge , isAuth , username , checkoutMode , abandonedFlag , isIscUser , isAbandonedCart , handleAbandonedCarts , loadAbandonedCart , errors , currencySign , showBundleModal , handleSelection , setCartQtyLoad , setLoadingText , ...restProps } = props;
    const { cart: activeCart = {}  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [count, setCount] = (0,react.useState)(0);
    const dispatch = (0,es/* useDispatch */.I0)();
    const [showConfirmationModal, setShowConfirmationModal] = (0,react.useState)(false);
    const { t  } = (0,esm/* useTranslation */.$G)("cart");
    const staticText = (0,localization/* getTranslations */.F)(t);
    (0,react.useEffect)(()=>{
        (0,utils/* getCartCount */.c0)(cartItems);
    }, [
        cartItems
    ]);
    let alertCount = 0;
    cartItems === null || cartItems === void 0 ? void 0 : cartItems.forEach((item)=>{
        if (item.outOfStock || item.noShipping) alertCount++;
    });
    const showAuthModal = ()=>{
        (0,analytics/* pushAnalyticsObjToDataLayer */.zY)({
            eventAction: "cart:landing page:your cart is empty:sign in",
            eventName: "cart:landing page:your cart is empty:sign in",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "sign in",
            internalLinkPosition: "cart",
            internalLinkType: "cart:navigation",
            internalLinkZoneName: "cart:landing page:your cart is empty",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        });
        dispatch((0,authSlice/* setAuthModalVisibility */.LY)({
            show: true
        }));
    };
    const getEventInfo = ()=>{
        return JSON.stringify({
            eventAction: "cart:landing page:your cart is empty:continue shopping",
            eventName: "cart:landing page:your cart is empty:continue shopping",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "continue shopping",
            internalLinkPosition: "cart",
            internalLinkType: "cart:navigation",
            internalLinkZoneName: "cart:landing page:your cart is empty",
            internalLinkURL:  true && window.location.origin + constants.continueShippingUrl,
            clickInternalLinks: "true"
        });
    };
    const noPadding = Boolean(cartItems === null || cartItems === void 0 ? void 0 : cartItems.length);
    const handleCopyCartId = ()=>{
        navigator.clipboard.writeText(cartKey).then(()=>{
            props.showToast("Cart ID copied to clipboard");
        }).catch((err)=>{
            console.error(err);
            props.showToast("Not able to copy the Cart ID");
        });
    };
    const cartRecoveryStatusTag = isAbandonedCart && activeCart.anonymousId === undefined && activeCart.cartState === "active" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cart-recovery-status",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(core_Tag, {
            text: staticText.notRecovered
        })
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cart-recovery-status",
        children: null
    });
    const copyCartIdButton = isAbandonedCart ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "copy-cart-id",
        children: [
            " ",
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                label: staticText.copyCartId,
                size: "small",
                className: "gbh-data-layer copy-cart-id-btn",
                type: "ghost",
                onClick: handleCopyCartId
            }),
            " "
        ]
    }) : null;
    const isValidLineItem = (item)=>{
        return item.category !== utils_constants/* INSTALL_SERVICES */._F && !item.isBundleChildItem;
    };
    const isAllSelected = ()=>{
        if (cartItems && cartItems.length) {
            for (const item of cartItems){
                if (!item.isBundleChildItem && item.category !== "Install Services") {
                    if (!item.isSelected) {
                        return false;
                    }
                }
            }
            return true;
        }
    };
    const selectableItemCount = (cartItems === null || cartItems === void 0 ? void 0 : cartItems.reduce((acc, item)=>{
        if (!item.isBundleChildItem && item.category !== "Install Services") {
            return acc + 1;
        }
        return acc;
    }, 0)) || 0;
    const selectedItemCount = (cartItems === null || cartItems === void 0 ? void 0 : cartItems.reduce((acc, item)=>{
        if (!item.isBundleChildItem && item.category !== "Install Services" && item.isSelected) {
            return acc + 1;
        }
        return acc;
    }, 0)) || 0;
    const handleDeleteSelected = async ()=>{
        const data = cartItems.filter((item)=>item.isSelected);
        const updateDataLayer = ()=>{
            data.forEach((item)=>(0,cartAnalytics/* addRemoveProductFromCartAnalytics */.UN)("cmp:click", item));
        };
        return (0,cartHelper/* removeCartItem */.B8)(data, updateDataLayer, null);
    };
    const redirectToPage = (e)=>{
        e.preventDefault();
        window.location.href = window.location.origin + constants.continueShippingUrl;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat(!noPadding && !isIscUser ? "no-padding" : "", " cart-landing__content"),
        "data-testid": "cartItemTile",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "row no-gutters cart-items",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row no-gutters",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: isIscUser && !abandonedFlag || !isAuth || !isIscUser ? "col-lg-12 col-sm-6 col-md-6 cart-header" : "col-lg-12 col-sm-6 col-md-6 cart-header mb-0",
                                children: [
                                    mode !== "share" && (cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "cart-items__title",
                                                role: "heading",
                                                "aria-level": "1",
                                                "aria-label": "".concat(staticText.yourCart, " ").concat(count, " items"),
                                                "data-testid": "cartItem-title",
                                                children: [
                                                    isAbandonedCart ? staticText.customerCart : staticText.yourCart,
                                                    " ",
                                                    "(",
                                                    (cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) > 0 ? (0,utils/* getCartCount */.c0)(cartItems) : 0,
                                                    ")"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "cart-items__header-info",
                                                children: [
                                                    isIscUser ? cartRecoveryStatusTag : null,
                                                    cartKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "share-cart-id ".concat(isIscUser ? "abandoned-cart-key" : ""),
                                                        children: staticText.yourSharedCartID(cartKey)
                                                    }) : null,
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "cart-id-share",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SocialShare/* default */.Z, {
                                                                id: "kf-order-summary",
                                                                dispatchCallback: dispatchCallback,
                                                                cartId: cartId,
                                                                analyticEventData: analyticEventData,
                                                                selectedItems: (cartItems === null || cartItems === void 0 ? void 0 : cartItems.filter((item)=>item.isSelected).map((item)=>item.sku)) || []
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                                className: "cart-actions delete ".concat(!selectedItemCount ? "disabled" : ""),
                                                                onClick: ()=>setShowConfirmationModal(true),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                    src: trash_icon.src,
                                                                    alt: "delete"
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }),
                                            cartKey ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                className: "mobile-share-cart-id ".concat(isIscUser ? "abandoned-cart-key" : ""),
                                                children: staticText.yourSharedCartID(cartKey)
                                            }) : null
                                        ]
                                    }) : null,
                                    mode === "share" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "cart-items__title",
                                        role: "heading",
                                        "aria-level": "1",
                                        "aria-label": "".concat(title, " ").concat(count, " items"),
                                        "data-testid": "cartItem-title",
                                        children: [
                                            title,
                                            " (",
                                            (cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) > 0 ? (0,utils/* getCartCount */.c0)(cartItems) : 0,
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        }),
                        mode !== "share" && showAlert && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row no-gutters",
                            id: "alert-wrapper",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "cart-items__alert",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        role: "alert",
                                        tabIndex: "0",
                                        className: "cart-items__alert-title",
                                        children: "".concat(staticText.alert, ": ")
                                    }),
                                    staticText.updateCartForDeliveryAlert,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        className: "cart-items__alert-link",
                                        onClick: ()=>(0,cartHelper/* scrollToError */.HZ)(true),
                                        children: staticText.reviewCart
                                    })
                                ]
                            })
                        }),
                        mode === "share" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "row no-gutters",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "col-12",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "order-summary ",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                        customClass: "cart-items__checkout-btn",
                                        label: isMerge ? staticText.mergeWithCart : staticText.addToMyCart,
                                        flexible: true,
                                        type: "black",
                                        onClick: onMerge
                                    })
                                })
                            })
                        }),
                        lib/* isMobile */.tq && mode === "share" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row cart-items__th--mobile no-gutters",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 col-sm-6 col-md-6 d-none d-sm-block"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 col-sm-6 col-md-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cart-items__download-print d-none d-lg-flex",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            role: "link",
                                            tabIndex: "0",
                                            onClick: ()=>window.print(),
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: print_grey === null || print_grey === void 0 ? void 0 : print_grey.src,
                                                    alt: staticText.print
                                                }),
                                                staticText.print
                                            ]
                                        })
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "row cart-items__th no-gutters ".concat((cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) ? "cart-table-header" : ""),
                            children: [
                                (cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 col-sm-6 col-md-6 d-sm-block px-0",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-left cart-items__td",
                                        "aria-hidden": "true",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "td-wrap",
                                            children: [
                                                mode !== "share" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "select",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                        onChange: (e)=>handleSelection(null, e.target.checked),
                                                        checked: isAllSelected(),
                                                        value: ""
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                                    className: "d-none d-sm-block",
                                                    children: staticText.item
                                                }),
                                                mode !== "share" && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        selectedItemCount,
                                                        "/",
                                                        selectableItemCount,
                                                        " items selected"
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "col-12 col-sm-6 col-md-6 align-self-end pr-0",
                                    children: (cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "row mx-0 px-0 cart-items__td-container",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-5 d-none d-sm-block cart-items__td cart-td-unit-price",
                                                "aria-hidden": "true",
                                                children: staticText.itemPrice
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(mode === "share" ? "col-2" : "col-3", " d-none d-sm-block text-center cart-items__td px-0"),
                                                "aria-hidden": "true",
                                                children: staticText.qty
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "col-4\n                  d-none d-sm-block text-right cart-items__td pr-0",
                                                "aria-hidden": "true",
                                                children: staticText.total
                                            })
                                        ]
                                    }) : null
                                })
                            ]
                        }),
                        !(cartItems === null || cartItems === void 0 ? void 0 : cartItems.length) && !loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: isIscUser && !abandonedFlag || !isAuth || !isIscUser ? "cart-items__no-items no-border" : "cart-items__no-items no-border p-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                    children: [
                                        !abandonedFlag ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "cart-items__no-items-message text-center",
                                            children: [
                                                "".concat(username ? username + "," : ""),
                                                " ",
                                                (ref = staticText.noItemsInCart) === null || ref === void 0 ? void 0 : ref.toLowerCase()
                                            ]
                                        }) : null,
                                        isIscUser && !abandonedFlag ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "isc-cart-message text-center",
                                            children: [
                                                " ",
                                                staticText.iscUserLoadMessage,
                                                " "
                                            ]
                                        }) : null
                                    ]
                                }),
                                isIscUser && abandonedFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_AbandonedCarts, {
                                    currencySign: currencySign,
                                    staticTexts: staticText,
                                    loadAbandonedCart: loadAbandonedCart,
                                    onClick: ()=>{
                                        handleAbandonedCarts(!abandonedFlag);
                                    }
                                }) : null,
                                !isAuth && !isIscUser ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                    className: "sing-in-cart-message text-center",
                                    children: [
                                        " ",
                                        staticText.signInItemsPreviously,
                                        " "
                                    ]
                                }) : null,
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: "cart-items__no-items-links d-flex text-center",
                                    children: [
                                        !isAuth && !isIscUser ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            label: "Sign In",
                                            className: "gbh-data-layer sing-in-cart",
                                            type: "black",
                                            role: "button",
                                            tabIndex: 0,
                                            onClick: ()=>showAuthModal()
                                        }) : null,
                                        !isIscUser && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            label: staticText.continueShopping,
                                            className: "gbh-data-layer",
                                            type: "ghost",
                                            onClick: redirectToPage,
                                            "data-gbh-data-layer": getEventInfo(),
                                            to: "#"
                                        }),
                                        isIscUser && !abandonedFlag ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                            label: staticText.abandonedCarts,
                                            className: "gbh-data-layer",
                                            type: "ghost",
                                            role: "button",
                                            to: "#",
                                            onClick: ()=>{
                                                handleAbandonedCarts(!abandonedFlag);
                                            }
                                        }) : null
                                    ]
                                })
                            ]
                        }) : null,
                        cartItems === null || cartItems === void 0 ? void 0 : cartItems.map((item)=>isValidLineItem(item) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CartItemTile/* default */.Z, {
                                i18n: staticText,
                                loading: loading,
                                ...props,
                                data: item,
                                dispatchCallback: dispatchCallback,
                                checkoutMode: mode === "share",
                                cartItems: cartItems,
                                errors: errors,
                                showBundleModal: showBundleModal,
                                handleSelection: handleSelection,
                                setLoadingText: setLoadingText
                            }, item.id))
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ConfirmationModal_ConfirmationModal, {
                showModal: showConfirmationModal,
                setShowModal: setShowConfirmationModal,
                onConfirm: handleDeleteSelected,
                onCancel: ()=>{},
                desc: isAllSelected() ? "Are you sure you want to delete your cart?" : "Are you sure you want to delete selected item(s) from the cart?"
            })
        ]
    });
};
/* harmony default export */ var cart_CartItems = (CartItems);


/***/ }),

/***/ 22358:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"AbandonedCarts":"AbandonedCarts_AbandonedCarts__8_AYf"};

/***/ }),

/***/ 15340:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"confirmationModal":"confirmation-modal_confirmationModal__LMVfw"};

/***/ }),

/***/ 60635:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"TagWrapper":"Tag_TagWrapper__bvGEQ"};

/***/ }),

/***/ 83461:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(5090);


/***/ }),

/***/ 89469:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(99182);

var _metaProps = __webpack_require__(69695);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProps = {
  target: '_blank'
};

var CSVDownload = function (_React$Component) {
  _inherits(CSVDownload, _React$Component);

  function CSVDownload(props) {
    _classCallCheck(this, CSVDownload);

    var _this = _possibleConstructorReturn(this, (CSVDownload.__proto__ || Object.getPrototypeOf(CSVDownload)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(CSVDownload, [{
    key: 'buildURI',
    value: function buildURI() {
      return _core.buildURI.apply(undefined, arguments);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          data = _props.data,
          headers = _props.headers,
          separator = _props.separator,
          enclosingCharacter = _props.enclosingCharacter,
          uFEFF = _props.uFEFF,
          target = _props.target,
          specs = _props.specs,
          replace = _props.replace;

      this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator, enclosingCharacter), target, specs, replace);
    }
  }, {
    key: 'getWindow',
    value: function getWindow() {
      return this.state.page;
    }
  }, {
    key: 'render',
    value: function render() {
      return null;
    }
  }]);

  return CSVDownload;
}(_react2.default.Component);

CSVDownload.defaultProps = Object.assign(_metaProps.defaultProps, defaultProps);
CSVDownload.propTypes = _metaProps.propTypes;
exports["default"] = CSVDownload;

/***/ }),

/***/ 26425:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _core = __webpack_require__(99182);

var _metaProps = __webpack_require__(69695);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CSVLink = function (_React$Component) {
  _inherits(CSVLink, _React$Component);

  function CSVLink(props) {
    _classCallCheck(this, CSVLink);

    var _this = _possibleConstructorReturn(this, (CSVLink.__proto__ || Object.getPrototypeOf(CSVLink)).call(this, props));

    _this.buildURI = _this.buildURI.bind(_this);
    return _this;
  }

  _createClass(CSVLink, [{
    key: 'buildURI',
    value: function buildURI() {
      return _core.buildURI.apply(undefined, arguments);
    }
  }, {
    key: 'handleLegacy',
    value: function handleLegacy(event) {
      var isAsync = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (window.navigator.msSaveOrOpenBlob) {
        event.preventDefault();

        var _props = this.props,
            data = _props.data,
            headers = _props.headers,
            separator = _props.separator,
            filename = _props.filename,
            enclosingCharacter = _props.enclosingCharacter,
            uFEFF = _props.uFEFF;


        var csvData = isAsync && typeof data === 'function' ? data() : data;

        var blob = new Blob([uFEFF ? '\uFEFF' : '', (0, _core.toCSV)(csvData, headers, separator, enclosingCharacter)]);
        window.navigator.msSaveBlob(blob, filename);

        return false;
      }
    }
  }, {
    key: 'handleAsyncClick',
    value: function handleAsyncClick(event) {
      var _this2 = this;

      var done = function done(proceed) {
        if (proceed === false) {
          event.preventDefault();
          return;
        }
        _this2.handleLegacy(event, true);
      };

      this.props.onClick(event, done);
    }
  }, {
    key: 'handleSyncClick',
    value: function handleSyncClick(event) {
      var stopEvent = this.props.onClick(event) === false;
      if (stopEvent) {
        event.preventDefault();
        return;
      }
      this.handleLegacy(event);
    }
  }, {
    key: 'handleClick',
    value: function handleClick() {
      var _this3 = this;

      return function (event) {
        if (typeof _this3.props.onClick === 'function') {
          return _this3.props.asyncOnClick ? _this3.handleAsyncClick(event) : _this3.handleSyncClick(event);
        }
        _this3.handleLegacy(event);
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props2 = this.props,
          data = _props2.data,
          headers = _props2.headers,
          separator = _props2.separator,
          filename = _props2.filename,
          uFEFF = _props2.uFEFF,
          children = _props2.children,
          onClick = _props2.onClick,
          asyncOnClick = _props2.asyncOnClick,
          enclosingCharacter = _props2.enclosingCharacter,
          rest = _objectWithoutProperties(_props2, ['data', 'headers', 'separator', 'filename', 'uFEFF', 'children', 'onClick', 'asyncOnClick', 'enclosingCharacter']);

      var isNodeEnvironment = typeof window === 'undefined';
      var href = isNodeEnvironment ? '' : this.buildURI(data, uFEFF, headers, separator, enclosingCharacter);

      return _react2.default.createElement(
        'a',
        _extends({
          download: filename
        }, rest, {
          ref: function ref(link) {
            return _this4.link = link;
          },
          target: '_self',
          href: href,
          onClick: this.handleClick()
        }),
        children
      );
    }
  }]);

  return CSVLink;
}(_react2.default.Component);

CSVLink.defaultProps = _metaProps.defaultProps;
CSVLink.propTypes = _metaProps.propTypes;
exports["default"] = CSVLink;

/***/ }),

/***/ 99182:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var isSafari = exports.isSafari = function isSafari() {
  return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
  );
};

var isJsons = exports.isJsons = function isJsons(array) {
  return Array.isArray(array) && array.every(function (row) {
    return (typeof row === "undefined" ? "undefined" : _typeof(row)) === 'object' && !(row instanceof Array);
  });
};

var isArrays = exports.isArrays = function isArrays(array) {
  return Array.isArray(array) && array.every(function (row) {
    return Array.isArray(row);
  });
};

var jsonsHeaders = exports.jsonsHeaders = function jsonsHeaders(array) {
  return Array.from(array.map(function (json) {
    return Object.keys(json);
  }).reduce(function (a, b) {
    return new Set([].concat(_toConsumableArray(a), _toConsumableArray(b)));
  }, []));
};

var jsons2arrays = exports.jsons2arrays = function jsons2arrays(jsons, headers) {
  headers = headers || jsonsHeaders(jsons);

  var headerLabels = headers;
  var headerKeys = headers;
  if (isJsons(headers)) {
    headerLabels = headers.map(function (header) {
      return header.label;
    });
    headerKeys = headers.map(function (header) {
      return header.key;
    });
  }

  var data = jsons.map(function (object) {
    return headerKeys.map(function (header) {
      return getHeaderValue(header, object);
    });
  });
  return [headerLabels].concat(_toConsumableArray(data));
};

var getHeaderValue = exports.getHeaderValue = function getHeaderValue(property, obj) {
  var foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function (o, p, i, arr) {
    var value = o[p];
    if (value === undefined || value === null) {
      arr.splice(1);
    } else {
      return value;
    }
  }, obj);

  return foundValue === undefined ? property in obj ? obj[property] : '' : foundValue;
};

var elementOrEmpty = exports.elementOrEmpty = function elementOrEmpty(element) {
  return typeof element === 'undefined' || element === null ? '' : element;
};

var joiner = exports.joiner = function joiner(data) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
  var enclosingCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"';

  return data.filter(function (e) {
    return e;
  }).map(function (row) {
    return row.map(function (element) {
      return elementOrEmpty(element);
    }).map(function (column) {
      return "" + enclosingCharacter + column + enclosingCharacter;
    }).join(separator);
  }).join("\n");
};

var arrays2csv = exports.arrays2csv = function arrays2csv(data, headers, separator, enclosingCharacter) {
  return joiner(headers ? [headers].concat(_toConsumableArray(data)) : data, separator, enclosingCharacter);
};

var jsons2csv = exports.jsons2csv = function jsons2csv(data, headers, separator, enclosingCharacter) {
  return joiner(jsons2arrays(data, headers), separator, enclosingCharacter);
};

var string2csv = exports.string2csv = function string2csv(data, headers, separator, enclosingCharacter) {
  return headers ? headers.join(separator) + "\n" + data : data.replace(/"/g, '""');
};

var toCSV = exports.toCSV = function toCSV(data, headers, separator, enclosingCharacter) {
  if (isJsons(data)) return jsons2csv(data, headers, separator, enclosingCharacter);
  if (isArrays(data)) return arrays2csv(data, headers, separator, enclosingCharacter);
  if (typeof data === 'string') return string2csv(data, headers, separator);
  throw new TypeError("Data should be a \"String\", \"Array of arrays\" OR \"Array of objects\" ");
};

var buildURI = exports.buildURI = function buildURI(data, uFEFF, headers, separator, enclosingCharacter) {
  var csv = toCSV(data, headers, separator, enclosingCharacter);
  var type = isSafari() ? 'application/csv' : 'text/csv';
  var blob = new Blob([uFEFF ? "\uFEFF" : '', csv], { type: type });
  var dataURI = "data:" + type + ";charset=utf-8," + (uFEFF ? "\uFEFF" : '') + csv;

  var URL = window.URL || window.webkitURL;

  return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
};

/***/ }),

/***/ 5090:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


__webpack_unused_export__ = ({
  value: true
});
exports.CSVLink = __webpack_unused_export__ = undefined;

var _Download = __webpack_require__(89469);

var _Download2 = _interopRequireDefault(_Download);

var _Link = __webpack_require__(26425);

var _Link2 = _interopRequireDefault(_Link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CSVDownload = __webpack_unused_export__ = _Download2.default;
var CSVLink = exports.CSVLink = _Link2.default;

/***/ }),

/***/ 69695:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({
  value: true
}));
exports.PropsNotForwarded = exports.defaultProps = exports.propTypes = undefined;

var _react = __webpack_require__(67294);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(45697);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = exports.propTypes = {
  data: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.array, _propTypes.func]).isRequired,
  headers: _propTypes.array,
  target: _propTypes.string,
  separator: _propTypes.string,
  filename: _propTypes.string,
  uFEFF: _propTypes.bool,
  onClick: _propTypes.func,
  asyncOnClick: _propTypes.bool,
  enclosingCharacter: _propTypes.string
};

var defaultProps = exports.defaultProps = {
  separator: ',',
  filename: 'generatedBy_react-csv.csv',
  uFEFF: true,
  asyncOnClick: false,
  enclosingCharacter: '"'
};

var PropsNotForwarded = exports.PropsNotForwarded = ['data', 'headers'];

/***/ })

}]);